import { render, staticRenderFns } from "./SectionRecategorisation.vue?vue&type=template&id=1312beb7&"
import script from "./SectionRecategorisation.vue?vue&type=script&lang=js&"
export * from "./SectionRecategorisation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports